import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmConfirmClickedPayload {
  professionalId?: string;
  candidateId?: string;
  /** Total shift rows shown on the page. */
  shiftCount: number;
  /** How many of those shifts the user selected before confirming. */
  selectedShiftCount: number;
  shiftIds?: string[];
  offerIds?: string[];
}

/**
 * Fires when the user clicks "Confirm" on the bulk "Confirm Shifts" page.
 *
 * This is a bulk action over N shifts for a single professional, so it carries no
 * single shift_id/offer_id — `shiftIds` / `offerIds` list exactly what was confirmed
 * and join back to the candidate_viewed impressions.
 *
 * NOTE (GOTU-4815): `candidate_count` is now always 1 (one professional per page).
 * It previously carried the number of shifts **selected**, which is now reported as
 * `selected_shift_count`, with the total shown as `shift_count` — any pre-GOTU-4815
 * chart reading candidate_count here was measuring shift selections.
 *
 * Event: dental_portal:bulk_confirm:confirm_clicked
 */
export function fireBulkConfirmConfirmClicked(
  payload: IBulkConfirmConfirmClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:confirm_clicked', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_count: payload.shiftCount,
    selected_shift_count: payload.selectedShiftCount,
    shift_ids: payload.shiftIds,
    offer_ids: payload.offerIds,
    candidate_count: 1,
  });
}
